/**
 * 通用vue过滤器
 */
var Moment = require('moment');
//
exports.install = (Vue) => {
    Vue.prototype.formatTime = function (timestamp, format = "YYYY-MM-DD HH:mm:ss") {
        if (!timestamp) return "";
        return Moment(timestamp).format(format)
    }
    Vue.prototype.formatWidthTime = function (timeStr, format = "YYYY-MM-DD") {
        let timestamp = new Date(timeStr).getTime();
        if (timestamp == 0) return "-";
        return Moment(timestamp).format(format)
    }
    Vue.prototype.formatReturnTime = function (time) {
        let timestamp = new Date(time).getTime()
        return timestamp == 0 ? "-" : time
    },
    //  自定义时间格式
    Vue.prototype.formatResultDate = function (timestamp,format) {
        Date.prototype.format = function (format) {
            var date = {
                "M+": this.getMonth() + 1,
                "d+": this.getDate(),
                "h+": this.getHours(),
                "m+": this.getMinutes(),
                "s+": this.getSeconds(),
                "q+": Math.floor((this.getMonth() + 3) / 3),
                "S+": this.getMilliseconds()
            };
            if (/(y+)/i.test(format)) {
                format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            for (var k in date) {
                if (new RegExp("(" + k + ")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length == 1 ?
                        date[k] : ("00" + date[k]).substr(("" + date[k]).length));
                }
            }
            return format;
        }
        var newDate = new Date();
        newDate.setTime(timestamp * 1000);
        return newDate.format(format);
    }
    //倒计时
    Vue.prototype.countDown=function(timestamp){
        // debugger
        let targetTime=new Date(timestamp).getTime()
        let now = new Date().getTime()
        let differ=Math.abs(targetTime-now)
        let arr=[]
        const DAY=24*60*60*1000,HOUR=60*60*1000,MINUTER=60*1000
        if(differ>=DAY){
            arr.push(Math.ceil(differ/DAY))
            differ=differ%DAY
        }else{
            arr.push(0)
        }
        if(differ>=HOUR){
            arr.push(Math.ceil(differ/HOUR))
            differ=differ%HOUR
        }else{
            arr.push(0)
        }
        if(differ>=MINUTER){
            arr.push(Math.ceil(differ/MINUTER))
            differ=differ%MINUTER
        }else{
            arr.push(0)
        }
        return {
            positive:targetTime-now>=0,
            time:arr
        }
    }
    // Vue.prototype.isPc = function () {
    //     var userAgentInfo = navigator.userAgent;
    //     var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
    //     var flag = true;
    //     for (var v = 0; v < Agents.length; v++) {
    //         if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
    //     }
    //     return flag;
    // }
}